module.exports = __webpack_public_path__ + "resources/img/nhn-cloud-ogp.0522cc7d6ad6f0ae2c9f8f921f8b3e72.png";